export * from '@fhs/routing/src/routes/rewards/offers/_layout';
export { default } from '@fhs/routing/src/routes/rewards/offers/_layout';
